import InboundTracking from './InboundTracking'

export default InboundTracking
// eslint-disable-next-line import/export
export * from './InboundTracking'
